import { render, staticRenderFns } from "./LookCaseDetail.vue?vue&type=template&id=06243884&"
import script from "./LookCaseDetail.vue?vue&type=script&lang=js&"
export * from "./LookCaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./LookCaseDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports